import { render, staticRenderFns } from "./youAreDoingGreat.vue?vue&type=template&id=8740a856&"
import script from "./youAreDoingGreat.vue?vue&type=script&lang=js&"
export * from "./youAreDoingGreat.vue?vue&type=script&lang=js&"
import style0 from "./youAreDoingGreat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCol,VProgressCircular})
